export default "__VITE_ASSET__Cy74bYUu__"